<template>

	<time-log-table
		v-if="$store.project.id"
		heading="Time Logs"
		:heading-small="'Project #'+$store.project.job_num+': '+$store.project.job_name"
		:show-job="false"
		:show-user="true"
		:show-user-classification="false"
		:filtering-tools="true"
		:editable="true"
		:filters="hourFilters"
		:default-filter-values="{dateFrom: defaultDateFromFilter}"
		:project-id="$store.project.id">
	</time-log-table>

</template>

<script>

import TimeLogTable from "@/components/super_components/TimeLogTable"
import TimeLogMixins from "@/mixins/TimeLogMixins.js"

export default {

	name: 'ProjectHours',
	components: {
		TimeLogTable
	},
	mixins: [
		TimeLogMixins
	],
	computed: {
		hourFilters() {
			return [
				["job_id",this.$store.project.id]
			]
		}
	}
}
</script>